module.exports = __webpack_public_path__ + "img/edit_background.8053a4d.svg";